//const ip='http://192.168.1.180:8080';  //开发
//const ip='http://192.168.1.10:8080';   //开发
const ip='http://39.98.59.30:41230';   //正式

const configApi={
    //获取站点信息
    getSiteData : ip+'/OTAnalysis/DataQuery/GetSite',
    //获取最新数据
    getRealTimeData : ip+'/OTAnalysis/DataQuery/GetRealData',
    //获取历史数据
    getHistoryData : ip+'/OTAnalysis/DataQuery/PostHistoryData',
    //获取EKMA数据
    getEkmaData : ip+'/OTAnalysis/DataQuery/GetEKMAMsg',
    //获取登录信息
    getLoginData : ip+'/OTAnalysis/DataQuery/GetLogin',

    // 进入页面
    getInfromEnter : ip + '/amapi/baseInfomation/GetCIParkResume',
    // 登录
    getLogin : ip+'/amapi/operatorInfomation/Login',
    // 获取雷达历史数据
    queryRadarHistoryMessage:ip+'/amapi/dataQuery/QueryRadarHistoryMessage',
};
export default configApi


// WEBPACK FOOTER //
// ./src/api/config.js